module.exports = __webpack_public_path__ + "img/cooling-water-smog-equipment-3.d284e2f4.png";